<template>
  <div class="prod-list">
    <template v-for="prod in prodData">
      <a :href="'#/prod/view?id=' + prod.id" class="mint-cell" :key="prod.id">
        <span class="mint-cell-mask"></span>
        <div class="mint-cell-left"></div>
        <div class="mint-cell-wrapper">
          <div class="mint-cell-title">
            <!---->
            <span class="mint-cell-text">{{prod.name}}</span>
            <span class="mint-cell-label">{{prod.introduction}}</span>
          </div>
          <div class="mint-cell-value is-link">
            <span></span>
          </div>
          <i class="mint-cell-allow-right"></i>
        </div>
        <div class="mint-cell-right"></div>
      </a>
    </template>
    <p v-if="prodData.length==0" style="text-align:center;width:100%;color: #999999;">暂无产品</p>
    <div style="padding:0 1rem;margin-top:2rem;">
      <mt-button @click.native="addProd" size="large" type="primary">+ 添加产品</mt-button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import { Cell, Button, Toast } from "mint-ui";

Vue.component(Button.name, Button);
Vue.component(Cell.name, Cell);
Vue.component(Toast.name, Toast);

export default {
  computed: mapState({
    prodData: state => state.proData,
    profile: state => state.userData
  }),
  methods: {
    addProd() {
      if (this.profile && this.profile.status != 9) {
        Toast("您的注册信息尚未审核通过，还不能添加产品。");
        return;
      }
      this.$router.push("/prod/edit");
    }
  },
  mounted() {
    if (this.prodData.length==0) {
      this.$store.dispatch('loadProdData');
    }
  }
};
</script>
<style scoped>
a {
  text-decoration: none;
}
.prod-list{
  padding-bottom: 5em;
}
.mint-cell-label{
  max-height: 2em;
  line-height: 2em;
  overflow: hidden;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
}
</style>